import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var SvgBlockedUserPlaceholderXs = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("circle", {
        cx: 9,
        cy: 9,
        r: 9,
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000
      }), /*#__PURE__*/jsx("circle", {
        cx: 9,
        cy: 9,
        r: 9,
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000
      }), /*#__PURE__*/jsx("circle", {
        cx: 9,
        cy: 9,
        r: 9,
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000
      }), /*#__PURE__*/jsx("circle", {
        cx: 9,
        cy: 9,
        r: 9,
        fill: props.iconColor ? props.iconColor : "#010505",
        fillOpacity: 0.38
      }), /*#__PURE__*/jsx("circle", {
        cx: 9,
        cy: 9,
        r: 8.1,
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : "#010505",
        fillOpacity: 0.38,
        d: "M11.267 10.353a2.86 2.86 0 0 0 .922-2.105V6.64a2.87 2.87 0 0 0-2.871-2.87h-.636a2.87 2.87 0 0 0-2.871 2.87v1.608c0 .833.355 1.582.922 2.106a1.236 1.236 0 0 1-.054 1.869 2.4 2.4 0 0 1-.677.382c-.95.344-2.146.852-3.03 1.474a.2.2 0 0 0-.032.293A8.08 8.08 0 0 0 9 17.1a8.08 8.08 0 0 0 6.06-2.728.2.2 0 0 0-.032-.293c-.884-.622-2.08-1.13-3.03-1.474-.25-.09-.478-.22-.677-.382a1.236 1.236 0 0 1-.054-1.87"
      }), /*#__PURE__*/jsx("circle", {
        cx: 12.668,
        cy: 12.15,
        r: 2.813,
        fill: "#9EA0A0",
        stroke: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
        strokeWidth: 0.9
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
        fillRule: "nonzero",
        d: "M12.668 8.887a3.262 3.262 0 1 1 0 6.525 3.262 3.262 0 0 1 0-6.525m2.074 2.131-3.207 3.206a2.363 2.363 0 0 0 3.207-3.205zm-2.075-1.23a2.363 2.363 0 0 0-1.828 3.858l3.324-3.325a2.35 2.35 0 0 0-1.495-.534z"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var SvgBlockedUserPlaceholderXs$1 = SvgBlockedUserPlaceholderXs;

export { SvgBlockedUserPlaceholderXs$1 as default };
